import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../../src/utill/validation";
import { Row, Select, Space } from "antd";
import axios from "axios";
import api from "../../../src/config.json";
import Table from "../../../src/Common/table";
import dateTime from "../../../src/utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../../src/utill/Excelimport";
import Loading from "../../../src/utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import { generateExcelFile } from "../../utill/download";
import moment from "moment";

const TracibilityReport2 = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const [Inputdata, setInputData] = useState({});
  const [tabledata, settabledata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [RMTypeList, setRMTypeList] = useState([]);
  const [RMIDList, setRMIDList] = useState([]);
  const [CopoundCodeList, setCopoundCodeList] = useState([]);
  const [VendorList, setVendorList] = useState([]);
  const [RMMasterList, setRMMasterList] = useState([]);
  const [InvoiceDateList, setInvoiceDateList] = useState([]);
  const [InvoiceNoList, setInvoiceNoList] = useState([]);
  const [TestReportList, setTestReportList] = useState([]);
  const [modelState, SetmodelState] = useState(false);
  const [errors, seterrors] = useState({});
  const [ViewData, setViewdata] = useState({});
  const [Compouncodereloader, setCompouncodereloader] = useState(false);

  

  const [columns1, setColumns1] = useState([
  
    {
      path: "ActivatedAt",
      label: "Activated At",
      content: (obj) => (
        <React.Fragment>
          <label>
            {obj.ActivatedAt && moment(obj.ActivatedAt).format("DD-MM-YYYY / hh:mm a")}
          </label>
        </React.Fragment>
      ),
    },
    {
      path: "MixingMill",
      label: "Mixing Mill",
      content: (obj) => (
        <>
          <label>{obj.MixingMill ?? "-"}</label>
        </>
      ),
    },
    {
      path: "From_SrNo",
      label: "Sheet",
      content: (obj) => (
        <>
          <label>{obj.From_SrNo + "-" + obj.Till_SrNo}</label>
        </>
      ),
    },
  
    {
      path: "DateOfMfg",
      label: "Date Of Manufacturing",
      content: (obj) => (
        <React.Fragment>
          <label>
            {obj.DateOfMfg && moment(obj.DateOfMfg).format("DD-MM-YYYY")}
          </label>
        </React.Fragment>
      ),
    },
    {
      path: "UseBy",
      label: "Date Of Manufacturing",
      content: (obj) => (
        <React.Fragment>
          <label>
            {obj.UseBy && moment(obj.UseBy).format("DD-MM-YYYY")}
          </label>
        </React.Fragment>
      ),
    },  {
      path: "UniqueID",
      label: "Unique ID",
      content: (obj) => (
        <React.Fragment>
          <label>
            {obj.UniqueID  ?? '-'}
          </label>
        </React.Fragment>
      ),
    },
   
  ])
  const [columns, setColumns] = useState([
    {
      path: "CompoundCode",
      label: "Compound Code",
      content: (obj) => (
        <>
          <label>{obj.CompoundCode ?? "-"}</label>
        </>
      ),
    },
    {
      path: "BatchCode",
      label: "Batch Code",
      content: (obj) => (
        <>
          <label>{obj.BatchCode ?? "-"}</label>
        </>
      ),
    },
    {
      path: "Kneader_ID",
      label: "Kneader ID",
      content: (obj) => (
        <>
          <label>{obj.Kneader_ID ?? "-"}</label>
        </>
      ),
    },
    {
      path: "KneaderAt",
      label: "Kneaded At",
      content: (obj) => (
        <React.Fragment>
          <label>
            {obj.KneaderAt && moment(obj.KneaderAt).format("DD-MM-YYYY / hh:mm a")}
          </label>
        </React.Fragment>
      ),
    },
    // { path: "KneadedQty", label: "KneadedQty" },
    // { path: "TwoRollerMixerID", label: "TwoRollerMixerID" },
    // { path: "Dateof Activation", label: "Dateof Activation" },

    {
      path: "GreenSheetStorageLocation",
      label: "Green Sheet Storage Location",
      content: (obj) => (
        <>
          <label>{obj.GreenSheetStorageLocation ?? "-"}</label>
        </>
      ),
    },
    // { path: "Polymer", label: "Polymer" ,content:obj=><><label>{obj.Polymer ??'-'}</label></>},
    {
      path: "TotalGreenSheetsQtyProduced",
      label: "Total Green Sheets Qty Produced",
      content: (obj) => (
        <>
          <label>{obj.TotalGreenSheetsQtyProduced ?? "-"}</label>
        </>
      ),
    },
    {
      path: "ProcessState",
      label: "Current State",
      content: (obj) => (
        <>
          <label>{obj.ProcessState ?? "-"}</label>
        </>
      ),
    },
  
  {
    key: "table",
    content: (user) =>
      user.Activation && user.Activation.length > 0 ? (
        <Table
        searchbar={false}
        id="TracibilityReport2"
        columns={columns1}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={user.Activation}
      />
   
      ) : (
        ""
      ),
  },
    // {
    //   key: "view",
    //   content: (user) =>
    //     user.Activation && user.Activation.length > 0 ? (
    //       <button
    //         // disabled={
    //         //   !getRightsForAccess("DynamicDataRights", RightName, "update")
    //         // }
    //         onClick={() => {
    //           SetmodelState(true);
    //           setViewdata(user);
    //         }}
    //         className="btn btn-sm btn-primary"
    //       >
    //         <FontAwesomeIcon icon={faEye} />
    //       </button>
    //     ) : (
    //       ""
    //     ),
    // },
  ]);

  useEffect(() => {
    Heading("Trace by RM");
    // getToolList();
    getVendorList();
    getRMDataEntryList();
  }, []);

  // const getToolList = () => {
  //   axios
  //     .get(api.api + "report2")
  //     .then((result) => {
  //       settabledata(result.data);
  //       console.log(result.data,"current ddgdd");
  //        const data = _.uniqBy(result.data, "RM_Type");
  //              const list = data.map((one) => ({
  //                Name: one.RM_Type,
  //                value: one.RM_Type,
  //              }));
  //       // setRMTypeList(list);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  useEffect(() => {
    const errors = validation.validate(Inputdata, schema);
    if (errors) {
      return;
    }else{
      handelGetData(Inputdata);

    }
  }, [Inputdata,Compouncodereloader])
  
  const getVendorList = () => {
    axios
      .get(api.api + "vendor")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.Vendor,
          value: one.Vendor,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMDataEntryList = () => {
    axios
      .get(api.api + "RMDataEntry")
      .then((result) => {
        console.log(result.data, "current api data entry list");
        const data = _.uniqBy(result.data, "RM_Type");
        const RMType = data.map((one) => ({
          Name: one.RM_Type,
          value: one.RM_Type,
        }));
        setRMTypeList(RMType);

        setRMMasterList(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSort = (sortColumn) => {
    if (tabledata.length > 0) {
      const sorted = _.orderBy(
        tabledata,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      settabledata(sorted);
    }
  };

  const schema = {
    RM_Type: joi.string().required(),
    RM_ID: joi.string().required(),
    Vendor: joi.string().required(),
    InvoiceDate: joi.string().required(),
    InvoiceNo: joi.string().required(),
    TestReportNo: joi.string().required(),
  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;
    // if(name ==='UnitOfMeasurement'){
    //   setInputData((prev) => ({
    //     ...prev,
    //     [name]: value,
    //   }));
    if (name === "RM_Type") {
      const filteredArray = _.filter(RMMasterList, { RM_Type: value });
      console.log(RMMasterList, "iowjfkdm", value, filteredArray);
      if (RMIDList.length > 0) {
        Inputdata.RM_ID = "";
        Inputdata.Vendor = "";
        Inputdata.InvoiceDate = "";
        Inputdata.InvoiceNo = "";
        Inputdata.TestReportNo = "";
        setVendorList([]);
        setTestReportList([]);
        setInvoiceNoList([]);
        setInvoiceDateList([]);
      }
       delete Inputdata.CompoundCode
      setCopoundCodeList([]);

      if (filteredArray.length > 0) {
        const data = _.uniqBy(filteredArray, "RM_ID");

        const list = data.map((one) => ({
          Name: one.RM_ID,
          value: one.RM_ID,
        }));
        setRMIDList(list);
      } else {
        console.warn("No Reservoirs found for the selected Reservoir_Type.");
        setRMIDList([]);
      }
    }

    if (name === "RM_ID") {
      const filteredArray = _.filter(RMMasterList, {
        RM_ID: value,
        RM_Type: Inputdata["RM_Type"],
      });
      console.log(RMMasterList, "dfvbdfbdfb", value, filteredArray);
      if (VendorList.length > 0) {
        Inputdata.Vendor = "";
        Inputdata.InvoiceDate = "";
        Inputdata.InvoiceNo = "";
        Inputdata.TestReportNo = "";
        setTestReportList([]);
        setInvoiceNoList([]);
        setInvoiceDateList([]);
      }
      
      delete Inputdata.CompoundCode
      setCopoundCodeList([]);
      if (filteredArray.length > 0) {
        const data = _.uniqBy(filteredArray, "Vendor");

        const list = data.map((one) => ({
          Name: one.Vendor,
          value: one.Vendor,
        }));

        // if(list.length == 1) {
        //   setInputData((prev) => ({
        //     ...prev,
        //     ['Vendor']: list[0]['Name'],
        //   }));
        // }
        setVendorList(list);
      } else {
        console.warn("No Reservoirs found for the selected Reservoir_Type.");
        setVendorList([]);
      }
    }
    if (name === "Vendor") {
      const filteredArray = _.filter(RMMasterList, {
        RM_ID: Inputdata["RM_ID"],
        RM_Type: Inputdata["RM_Type"],
        Vendor: value,
      });
      console.log(RMMasterList, "dfvbdfbdfb", value, filteredArray);
      if (InvoiceDateList.length > 0) {
        Inputdata.InvoiceDate = "";
        Inputdata.InvoiceNo = "";
        Inputdata.TestReportNo = "";
        setTestReportList([]);
        setInvoiceNoList([]);
      }
      delete Inputdata.CompoundCode
      setCopoundCodeList([]);
      if (filteredArray.length > 0) {
        const data = _.uniqBy(filteredArray, "InvoiceDate");

        const list = data.map((one) => ({
          Name: one.InvoiceDate,
          value: one.InvoiceDate,
        }));
        // if(list.length == 1) {
        //   setInputData((prev) => ({
        //     ...prev,
        //     ['InvoiceDate']: list[0]['Name'],
        //   }));
        //   handleOnChange({currentTarget:{name:'InvoiceDate',value:list[0]['Name']}})
        // }
        setInvoiceDateList(list);
      } else {
        console.warn("No Reservoirs found for the selected Reservoir_Type.");
        setInvoiceDateList([]);
      }
    }
    if (name === "InvoiceDate") {
      const filteredArray = _.filter(RMMasterList, {
        RM_ID: Inputdata["RM_ID"],
        RM_Type: Inputdata["RM_Type"],
        Vendor: Inputdata["Vendor"],
        InvoiceDate: value,
      });
      console.log(RMMasterList, "23423", value, filteredArray);
      if (InvoiceNoList.length > 0) {
        Inputdata.InvoiceNo = "";
        Inputdata.TestReportNo = "";
        setTestReportList([]);
      }
      delete Inputdata.CompoundCode
      setCopoundCodeList([]);
      if (filteredArray.length > 0) {
        const data = _.uniqBy(filteredArray, "InvoiceDate");

        const list = data.map((one) => ({
          Name: one.InvoiceNo,
          value: one.InvoiceNo,
        }));
        // if(list.length == 1) {
        //   setInputData((prev) => ({
        //     ...prev,
        //     ['InvoiceNo']: list[0]['Name'],
        //   }));
        //   handleOnChange({currentTarget:{name:'InvoiceNo',value:list[0]['Name']}})

        // }
        setInvoiceNoList(list);
      } else {
        console.warn("No Reservoirs found for the selected Reservoir_Type.");
        setInvoiceNoList([]);
      }
    }
    if (name === "InvoiceNo") {
      const filteredArray = _.filter(RMMasterList, {
        RM_ID: Inputdata["RM_ID"],
        RM_Type: Inputdata["RM_Type"],
        Vendor: Inputdata["Vendor"],
        InvoiceDate: Inputdata["InvoiceDate"],
        InvoiceNo: value,
      });
      console.log(RMMasterList, "ssfsdfsdfsdf", value, filteredArray);
      if (TestReportList.length > 0) {
        Inputdata.InvoiceNo = "";
        Inputdata.TestReportNo = "";
      }
      delete Inputdata.CompoundCode
      setCopoundCodeList([]);
      if (filteredArray.length > 0) {
        const data = _.uniqBy(filteredArray, "InvoiceNo");

        const list = data.map((one) => ({
          Name: one.TestReportNo,
          value: one.TestReportNo,
        }));
        // if(list.length == 1) {
        //   setInputData((prev) => ({
        //     ...prev,
        //     ['TestReportNo']: list[0]['Name'],
        //   }));
        //   handleOnChange({currentTarget:{name:'TestReportNo',value:list[0]['Name']}})

        // }
        setTestReportList(list);
        setCompouncodereloader(!Compouncodereloader);
      } else {
        console.warn("No Reservoirs found for the selected Reservoir_Type.");
        setTestReportList([]);
      }
    }
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // }
  };
  const handleHideModel = () => {
    SetmodelState(false);
  };
  const handelGetData = (data) => {
    // Create a shallow copy of the input data
    const checksheet = { ...data };
  
    // Check if CompoundCode is undefined
    if (checksheet.CompoundCode === undefined) {
      checksheet.Type = "CompoundCode";
      setLoader(true);
  
      axios
        .post(`${api.api}report2`, checksheet)
        .then((result) => {
          const list = result.data.map((item) => ({
            label: item.CompoundCode,
            value: item.CompoundCode,
          }));
  
  
          if (list.length > 0) {
            setCopoundCodeList(list);
          } else {
            setCopoundCodeList([]);
            swal("No Compound Code Found");
          }
  
          setLoader(false);
        })
        .catch((err) => {
          handleError(err);
          setLoader(false);
        });
    } else {
      // Remove the Type field if CompoundCode is defined
      delete checksheet.Type;
  
      setLoader(true);
  
      axios
        .post(`${api.api}report2`, checksheet)
        .then((result) => {
          settabledata(result.data);
          setLoader(false);
        })
        .catch((err) => {
          handleError(err);
          setLoader(false);
        });
    }
  };
  
  // Helper function for error handling
  const handleError = (err) => {
    if (err.response && err.response.data) {
      swal(err.response.data.message, { dangerMode: true });
    } else {
      console.error("An error occurred:", err);
    }
  };
  
  // const handelGetData = (data) => {
  //   // return
  //   const checksheet = { ...data };

  //   // const errors = validation.validate(checksheet, schema);
  //   // if (errors) {
  //   //   seterrors(errors);
  //   //   return;
  //   // }

  //   if (checksheet.CompoundCode === undefined) {
  //     checksheet.Type = "CompoundCode";
  //     setLoader(true);

  //     axios
  //       .post(api.api + "report2", checksheet)
  //       .then((result) => {
  //         const list = result.data.map((item) => ({
  //           label: item.CompoundCode,
  //           value: item.CompoundCode,
  //         }));
  //         console.log(list,"vfdjndjfkbn",list.length);
  //         if(result.data && result.data.length > 0) {

  //           setCopoundCodeList(list);
  //         }{
  //           setCopoundCodeList([]);

  //            swal("No Compound Code Found");
  //         }

  //         setLoader(false);
  //       })
  //       .catch((err) => {
  //         if (err.response && err.response.data) {
  //           swal(err.response.data.message, { dangerMode: true });
  //         }
  //         console.log(err);
  //         setLoader(false);
  //       });
  //   } else {
  //     delete checksheet.Type;

  //     setLoader(true);

  //     axios
  //       .post(api.api + "report2", checksheet)
  //       .then((result) => {
  //         // swal("Data Update Successfully");
  //         settabledata(result.data);
  //         setLoader(false);
  //       })
  //       .catch((err) => {
  //         if (err.response && err.response.data) {
  //           swal(err.response.data.message, { dangerMode: true });
  //         }
  //         console.log(err);
  //         setLoader(false);
  //       });
  //   }
  // };
  return (
    <>
      {loader ? <Loading /> : <></>}
      <div className="">
        <Row className="">
          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                RM Type
              </label>
              <AntdSelect
                placeholder="RM Type"
                onChange={(value) => {
                  handleOnChange({
                    currentTarget: { name: "RM_Type", value: value },
                  });
                }}
                value={Inputdata.RM_Type || []}
                style={{ width: "100%" }}
              >
                {RMTypeList.map((one) => {
                  return (
                    <AntdSelect.Option key={one.Name} value={one.Name}>
                      {one.Name}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.RM_Type && (
                <div className="alert small alert-danger">
                  {errors["RM_Type"]}
                </div>
              )}
            </div>
          </Col>

          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                RM ID
              </label>
              <AntdSelect
                placeholder="RM ID"
                onChange={(value) => {
                  handleOnChange({
                    currentTarget: { name: "RM_ID", value: value },
                  });
                }}
                value={Inputdata.RM_ID || []}
                style={{ width: "100%" }}
              >
                {RMIDList.map((one) => {
                  return (
                    <AntdSelect.Option key={one.Name} value={one.Name}>
                      {one.Name}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.RM_ID && (
                <div className="alert small alert-danger">
                  {errors["RM_ID"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                Vendor
              </label>
              <AntdSelect
                placeholder="Vendor"
                onChange={(value) => {
                  handleOnChange({
                    currentTarget: { name: "Vendor", value: value },
                  });
                }}
                value={Inputdata.Vendor || []}
                style={{ width: "100%" }}
              >
                {VendorList.map((one) => {
                  return (
                    <AntdSelect.Option key={one.Name} value={one.Name}>
                      {one.Name}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.Vendor && (
                <div className="alert small alert-danger">
                  {errors["Vendor"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                Invoice Date
              </label>
              <AntdSelect
                placeholder="InvoiceDate"
                onChange={(value) => {
                  handleOnChange({
                    currentTarget: { name: "InvoiceDate", value: value },
                  });
                }}
                value={
                  (Inputdata.InvoiceDate &&
                    moment(Inputdata.InvoiceDate).format("DD-MM-YYYY")) ||
                  []
                }
                style={{ width: "100%" }}
              >
                {InvoiceDateList.map((one) => {
                  return (
                    <AntdSelect.Option key={one.Name} value={one.Name}>
                      {moment(one.Name).format("DD-MM-YYYY")}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.InvoiceDate && (
                <div className="alert small alert-danger">
                  {errors["InvoiceDate"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                Invoice Number
              </label>
              <AntdSelect
                placeholder="InvoiceNo"
                onChange={(value) => {
                  handleOnChange({
                    currentTarget: { name: "InvoiceNo", value: value },
                  });
                }}
                value={Inputdata.InvoiceNo || []}
                style={{ width: "100%" }}
              >
                {InvoiceNoList.map((one) => {
                  return (
                    <AntdSelect.Option key={one.Name} value={one.Name}>
                      {one.Name}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.InvoiceNo && (
                <div className="alert small alert-danger">
                  {errors["InvoiceNo"]}
                </div>
              )}
            </div>
          </Col>

          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                Test Certification No.
              </label>
              <AntdSelect
                placeholder="TestReportNo"
                onChange={(value) => {
                  handleOnChange({
                    currentTarget: { name: "TestReportNo", value: value },
                  });
                }}
                value={Inputdata.TestReportNo || []}
                style={{ width: "100%" }}
              >
                {TestReportList.map((one) => {
                  return (
                    <AntdSelect.Option key={one.Name} value={one.Name}>
                      {one.Name}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.TestReportNo && (
                <div className="alert small alert-danger">
                  {errors["TestReportNo"]}
                </div>
              )}
            </div>
          </Col>

         
          <Col sm={3}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost" className="">
                Compound Code{" "}
              </label>
              {/* <AntdSelect
          placeholder="CompoundCode"
           mode="multiple"
          onChange={(value) => {
           
            handleOnChange({
              currentTarget: { name: "CompoundCode", value: value },
            });
          }}
          
          value={Inputdata.CompoundCode || []}
          style={{ width: "100%" }}
        >
          {CopoundCodeList.map((one) => {
            return (
              <AntdSelect.Option key={one.Name} value={one.Name}>
                {one.Name}
              </AntdSelect.Option>
            );
          })}
        </AntdSelect> */}
              <Select
                maxTagCount={"responsive"}
                mode="multiple"
                placeholder="Select Compound Code"
                value={Inputdata.CompoundCode}
                onChange={(values) => {
                  if (values.includes("All")) {
                    if (
                      Inputdata.CompoundCode &&
                      Inputdata.CompoundCode.length === CopoundCodeList.length
                    ) {
                      handleOnChange({
                        currentTarget: { name: "CompoundCode", value: [] },
                      });
                    } else {
                      handleOnChange({
                        currentTarget: { name: "CompoundCode", value: ["All"] },
                      });
                    }
                  } else {
                    // Update selected values normally
                    handleOnChange({
                      currentTarget: { name: "CompoundCode", value: values },
                    });
                  }
                }}
                style={{ width: "100%" }}
                options={CopoundCodeList && CopoundCodeList.length > 0 ?[{ label: "All", value: "All" }, ...CopoundCodeList]:[]}
              />
              {errors.CompoundCode && (
                <div className="alert small alert-danger">
                  {errors["CompoundCode"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={2} className="d-flex align-items-center">
            <button
              // disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
              className="btn-sm btn-primary mt-3"
              onClick={() => {
                handelGetData(Inputdata);
              }}
            >
              Apply
            </button>
          </Col>
        </Row>
      </div>
      <Modal
        backdrop={"static"}
        className=""
        size={"lg"}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Activation Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}
          <Row>
            <Col sm={12}>
              <div className="form-group mt-2 ">
                <div className="">
                  <table className="table table-striped small table-bordered table-sm table-hover common my-1">
                    <thead className="small">
                      <tr className="table-primary text-center common-anchor">
                        <td>Activated At</td>
                        <td>Roller ID</td>
                        <td>Sheets</td>
                        <td>Manufacturing date</td>
                        <td>Use By</td>
                        <td>Unique ID</td>
                      </tr>
                    </thead>
                    <tbody>
                      {ViewData.Activation &&
                        ViewData.Activation.length > 0 &&
                        ViewData.Activation.map((item) => (
                          <tr className="text-center">
                            <td>
                              {moment(item.ActivatedAt).format("DD-MM-YYYY")}
                            </td>
                            <td>{item.MixingMill}</td>
                            <td>{item.From_SrNo + "-" + item.Till_SrNo}</td>
                            <td>
                              {moment(item.DateOfMfg).format("DD-MM-YYYY")}
                            </td>
                            <td>{moment(item.UseBy).format("DD-MM-YYYY")}</td>
                            <td>{item.UniqueID}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {errors.InvoiceNo && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceNo"]}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleHideModel()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="">
      {tabledata.length > 0 ? (<button className="btn-primary btn-sm" 
          onClick={() => handleDownloadExcel("TracibilityReport2")}
          >
            Download Report
          </button>):''}
        {/* <div
          className="uiverse"
          onClick={() => handleDownloadExcel("TracibilityReport2")}
        >
          <span className="tooltip">Dowload Excel File</span>
          <span>Download</span>
        </div> */}
        {tabledata.length < 0 ? (
          "Data Not Available"
        ) : (
          <Table
            id="TracibilityReport2"
            columns={columns}
            onSort={handleSort}
            sortColumn={sortColumn}
            data={tabledata}
          />
        )}
      </div>
    </>
  );
};

export default TracibilityReport2;
